<template>
  <v-card flat color="transparent" class="elevation-12" style="">
    <div style="margin: auto 3%">
      <!-- search categories -->
      <!-- search by word -->
      <div
        style="
          min-width: 700px;
          display: flex;
          flex-flow: wrap;
          justify-content: start;
          align-items: center;
          height: 60px;
        "
      >
        <div style="font-size: 23px; font-weight: bold; width: 120px">
          Category
        </div>
        <v-select
          v-model="column"
          label="Category"
          :items="searchSelects"
          item-text="name"
          item-value="value"
          style="max-width: 160px; min-width: 100px"
          single-line
          color="#05523E"
        />
        <v-text-field
          v-model="search"
          clearable
          style="
            margin: auto 10px;
            max-width: 150px;
            min-width: 100px;
            height: 62px;
          "
          placeholder="Search"
          v-on:keyup.enter="searchByWord"
        />
        <v-btn
          class="white--text elevation-5 rounded-lg"
          color="#05523E"
          style="max-width: 140px; min-width: 120px; height: 35px"
          @click="searchByWord"
          >Search</v-btn
        >
        <v-btn
          @click="checkTemplateAndUpdate"
          class="rounded-lg"
          style="color: #05523e; height: 40px; position: absolute; right: 3%"
          >Template Refresh</v-btn
        >
      </div>
      <div v-show="isShow" style="padding-bottom: 20px; margin-top: 10px">
        <v-data-table
          :headers="headers"
          :items="$store.state.account.customerList"
          :page.sync="page_No"
          :items-per-page="10"
          hide-default-footer
          class="elevation-3"
          :loading="loading"
        >
          <!-- <template v-slot:header="{ props: { headers } }">
                    <thead>
                        <tr>
                        <th v-for="h in headers" v-bind:key="h.text">
                            <span style="color: black; font-weight: bold; font-size: 17px;">{{h.text}}</span>
                        </th>
                        </tr>
                    </thead>
                    </template> -->
          <template v-slot:item="{ item }">
            <tr @click="clickRow(item.CustNum, item.Company)">
              <td>{{ item.CustNum }}</td>
              <td>{{ item.Company }}</td>
              <td>{{ item.First_Name }}</td>
              <td>{{ item.Last_Name }}</td>
              <td>{{ item.Phone }}</td>
              <td>{{ item.address }}</td>
              <td>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="transparent"
                      class="elevation-0"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item-title
                      @click="openEditCustomerModal(item.CustNum)"
                      style="
                        padding: 0px 15px;
                        font-size: 15px;
                        cursor: pointer;
                      "
                      >Edit</v-list-item-title
                    >
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            style="padding-top: 8px"
            color="#05523E"
            v-model="page_No"
            :length="$store.state.account.customerPages"
            :total-visible="10"
            @input="movePage"
          />
          <div v-if="$store.state.common.editCustomerModalView">
            <v-dialog
              style="height: 100%"
              class="rounded-lg"
              v-model="$store.state.common.editCustomerModalView"
              width="450"
            >
              <EditCustomerModal @getCustomers="getCustomers" />
            </v-dialog>
          </div>
          <div
            v-if="$store.state.common.templateModalView && selectedRowCustNum"
          >
            <v-dialog
              class="rounded-lg"
              v-model="$store.state.common.templateModalView"
              width="1900"
            >
              <TemplateModal
                :loading="loading"
                style="min-height: 300px"
                :custNum="selectedRowCustNum"
                :companyName="selectedRowCompany"
              ></TemplateModal>
            </v-dialog>
          </div>
        </div>
      </div>
      <div
        v-show="!$store.state.common.isLoading && !isShow"
        style="font-size: 20px"
      >
        <div
          style="
            margin: 0% 0% 0% 420px;
            font-size: 40px;
            color: #05523e;
            font-weight: bold;
          "
        >
          No data was retrieved.
        </div>
        <img
          style="width: 700px; height: 600px; margin: 0% 0% 0% 250px"
          src="@/assets/noData.jpg"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import EditCustomerModal from "@/components/modal/EditCustomerModal.vue";
import TemplateModal from "@/components/modal/TemplateModal.vue";
import { runGqlQuery, runGqlMutation } from "@/graphql/gqlUtil.js";
import { GETCUSTOMERLENGTH } from "@/graphql/AccountQueries.js";
import { CHECKTEMPLATEANDUPDATE } from "@/graphql/AccountMutations.js";

export default {
  components: {
    EditCustomerModal,
    TemplateModal,
  },
  data() {
    return {
      searchSelects: [
        { name: "Category", value: "" },
        { name: "Cust Num", value: "CustNum" },
        { name: "Company", value: "Company" },
        { name: "First Name", value: "First_Name" },
        { name: "Last Name", value: "Last_Name" },
        { name: "Phone Number", value: "Phone" },
        { name: "Address", value: "Address" },
      ],
      column: "",
      search: "",
      page_No: 1,
      items: [{ tabName: "Customer" }, { tabName: "Employee" }],
      headers: [
        {
          text: "CustNum",
          align: "start",
          value: "CustNum",
          sort: (a, b) => a.localeCompare(b),
        },
        { text: "Company", value: "Company" },
        {
          text: "First Name",
          value: "First_Name",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Last Name",
          value: "Last_Name",
          sort: (a, b) => a.localeCompare(b),
        },
        { text: "Phone Number", value: "Phone" },
        {
          text: "Address",
          value: "address",
          sort: (a, b) => a.localeCompare(b),
        },
        { text: "", value: "" },
      ],
      selectedRowCustNum: "",
      selectedRowCompany: "",
      isShow: true,
      loading: false,
    };
  },
  props: {
    source: String,
  },
  async created() {
    this.loading = true;
    await this.getCustomers();
    await this.getCustomersPage();
    await this.$store.dispatch("invoice/getCategory");
    this.loading = false;
  },
  methods: {
    async checkTemplateAndUpdate() {
      const checkTemplate = await runGqlMutation(CHECKTEMPLATEANDUPDATE, {});
      console.log(checkTemplate.checkTemplateAndUpdate);
      if (checkTemplate.checkTemplateAndUpdate === 1) {
        // 업데이트 됐을때
        return this.$store.commit("common/snackOn", {
          text: "Template items are updates!",
        });
      } else {
        return this.$store.commit("common/snackOn", {
          text: "There are no updated template items.",
        });
      }
    },
    async getCustomersPage() {
      try {
        const req = { Column: this.column, Search: this.search };

        const customerPage = await runGqlQuery(GETCUSTOMERLENGTH, req);

        this.$store.state.account.customerPages = Math.ceil(
          customerPage.getCustomersLength.Length / 10
        );
      } catch (err) {
        console.error(err);
      }
    },
    async getCustomers() {
      try {
        const req = {
          Column: this.column,
          Search: this.search,
          Page_No: this.page_No - 1,
          Page_Size: 10,
        };
        const result = await this.$store.dispatch(
          "account/getCustomerList",
          req
        );
        if (result === "no data") {
          this.isShow = false;
        } else {
          this.isShow = true;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async clickRow(custNum, company) {
      try {
        this.selectedRowCustNum = custNum;
        this.selectedRowCompany = company;
        this.$store.commit("common/changeTemplateModalView");
        this.loading = true;
        await this.$store.dispatch("invoice/getTemplates", {
          CustNum: custNum,
        });
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async searchByWord() {
      this.loading = true;
      try {
        if (this.column === "" && this.search == null) {
          await this.searchCustomer();
        } else if (this.column === "" && this.search !== "") {
          this.loading = false;
          return this.$store.commit("common/snackErrOn", {
            text: "Please select a category.",
          });
        }
        await this.searchCustomer();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async searchCustomer() {
      this.loading = true;
      try {
        await this.getCustomersPage();
        this.page_No = 1;
        await this.getCustomers();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async openEditCustomerModal(custNum) {
      try {
        await this.$store.dispatch("account/getCustomerOne", {
          Search: custNum,
        });
        this.$store.commit("common/changeEditCustomerModalView");
      } catch (err) {
        console.error(err);
      }
    },
    async movePage(page) {
      this.loading = true;
      try {
        this.page_No = page;
        await this.getCustomers();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
  },
};
</script>
